import axios from 'axios'

import {
  AddBonusesRequest,
  AddBonusesResponse,
  FetchBonusTypesAvailableRequest,
  FetchBonusTypesAvailableResponse,
  FetchBonusTypesAvailableResponseWithHeader,
  BonusData,
  ResponseBonus,
} from '../model/bonus.model'

import { getToken } from '~/net'

export interface FetchBonusProps {
  tariffId: string
  subscriptionId: string
  provinceId: string
  brand: string
  sub: string
}
class BonusService {
  constructor(private apiGateway: string) {}

  fetchBonusesAvailable(
    FetchBonusTypesAvailableRequest: FetchBonusTypesAvailableRequest,
  ): Promise<FetchBonusTypesAvailableResponse> {
    const { subscriptionId, tariffId, provinceId, brand, sub } = FetchBonusTypesAvailableRequest

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token.access_token}` }
        }

        return axios.get<FetchBonusTypesAvailableResponseWithHeader>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/bonuses/available`,
          {
            params: {
              tariffId,
              provinceId,
            },
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })

      .then((resp) => {
        const dataWrapped = resp.data as FetchBonusTypesAvailableResponseWithHeader
        const obj = {
          total: dataWrapped.total,
          hasCompatibles: dataWrapped.hasCompatibles,
          items: dataWrapped.items.map((ele) => ele.bonusType),
        }
        return obj
      })
  }

  addBonuses(
    body: AddBonusesRequest,
    subscriptionId: string,
    brand: string,
    sub: string,
  ): Promise<AddBonusesResponse> {
    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token.access_token}` }
        }

        return axios.put<AddBonusesResponse>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/bonuses`,
          body,
          {
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => {
        const { data } = resp

        return data as AddBonusesResponse
      })
  }

  fetchBonusService(fetchBonusServiceProps: FetchBonusProps): Promise<ResponseBonus> {
    const { tariffId, subscriptionId, provinceId, brand, sub } = fetchBonusServiceProps
    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token.access_token}` }
        }

        return axios.get<BonusData>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/bonuses`,
          {
            params: {
              tariffId,
              provinceId,
            },
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => ({ subscriptionId: String(subscriptionId), bonus: resp.data }))
  }
}

export default BonusService
